
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/visit/msas-restaurant",
      function () {
        return require("private-next-pages/visit/msas-restaurant.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/visit/msas-restaurant"])
      });
    }
  